import { Injectable, Inject, DOCUMENT, inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { MetaConfig, MetaPayload } from './meta.model';
import { META_CONFIG } from './meta.constant';

import { arrayify } from '../core';

@Injectable()
export class MetaService {

  #title = inject(Title);
  #meta = inject(Meta);
  #config = inject(META_CONFIG);
  #document = inject(DOCUMENT);

  set(meta: MetaPayload) {
    let fullTitle: string;

    if (meta?.title) {
      fullTitle = this._getTitle(meta.title);
    } else {
      fullTitle = this.#config.baseTitle;
    }

    if (meta?.title !== undefined) {
      this.#title.setTitle(fullTitle);
    }

    if (meta?.ogTitle !== undefined) {
      const fullOgTitle = meta.ogTitle
        ? this._getTitle(meta.ogTitle)
        : this.#config.baseTitle;

      this.#meta.updateTag({
        content: fullOgTitle,
        property: 'og:title'
      });

      this.#meta.updateTag({
        content: fullOgTitle,
        name: 'twitter:title'
      });
    }

    let localHref = meta?.image;

    const parsedHref = this.#document.location.href.split('/');
    const href = parsedHref[0] + '//' + parsedHref[2];

    if (meta?.image && meta?.image.startsWith('/')) {
      localHref = href + meta.image;
    }

    this.#meta.updateTag({
      content: localHref,
      property: 'og:image'
    });

    const ogDesc = meta?.ogDescription || meta?.description;

    this.#meta.updateTag({
      content: ogDesc,
      property: 'og:description'
    });

    this.#meta.updateTag({
      content: ogDesc,
      name: 'twitter:description'
    });

    this.#meta.updateTag({
      content: this.#document.location.href,
      property: 'og:url'
    });

    this.#meta.updateTag({
      content: 'website',
      property: 'og:type'
    });

    this.#meta.updateTag({
      content: 'summary_large_image',
      name: 'twitter:card'
    });

    if (meta?.twitterImage) {

      let localTwitterHref = meta.twitterImage;

      if (meta?.twitterImage.startsWith('/')) {
        localTwitterHref = href + meta?.twitterImage;
      }

      this.#meta.updateTag({
        content: localTwitterHref,
        name: 'twitter:image'
      });

    }
  }

  private _getTitle(title: string | string[]) {
    return `${arrayify(title).join(` ${this.#config.separator} `)} ${this.#config.separator} ${this.#config.baseTitle}`;
  }
}
